import { ReactNode } from 'react';

function isURLValid(url: string | ReactNode) {
  if (typeof url !== 'string') return false;

  try {
    const test = new URL(url);
    return test.href;
  } catch {
    return false;
  }
}

export default isURLValid;
